import React from 'react';
import PropTypes from 'prop-types';

import PersonImg from 'inside-out/images/medicare/person-1.png';

import {
	innerWrapperStyle,
	wrapperStyle,
	titleStyle,
	textStyle,
  resourceWrapper,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';

import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard'

const MedicareForHealthProfessionalsStep4Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
          <h1 className={titleStyle}>Access to Maximum Intensity of Treatment</h1>
          <div className={textStyle}>
            <p>90266-90269 (continue beyond 30 EDPT services)</p>
            <p>To access more than 30 EDPT treatment services in the 12 month period, patients are required to have an additional GP review (the ‘fourth review’) to ensure the highest intensity of treatment is appropriate. Subject to this review, a patient can access the maximum of 40 EDPT treatment services in a 12 month period. Again, the mental health professional is required to provide a report to the GP prior to this review.</p>
          </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle} style={{display: 'flex' }}>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/psychological-treatment-review-template' }
            audiences={ [] }
            title={ 'Letter from Psych Session 30' }
            body={ 'The psychological treatment provider can use this template for a report back to the medical practitioner prior to care plan reviews at or before session 10, 20 and 30' }
            date={ '1 Nov, 2019' }
          />
        </div>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/gp-care-plan-review-template' }
            audiences={ [] }
            title={ 'GP Care Plan Review Template' }
            body={ 'The medical practitioner can use this template to complete the Eating Disorder Care Plan Review at session 10, 20 and 30.' }
            date={ '1 Nov, 2019' }
          />
        </div>
      </div>
    </section>
  </div>
);

export { MedicareForHealthProfessionalsStep4Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-health-professionals/step-4.js